import { G } from "../../constants/theme";
import Label from "./Label";
import BigTitle from "./BigTitle";
import { Wrap } from "./Layout";

export default function PageHero({ label, title, sub }) {
  return (
    <div
      style={{
        background: G.deep,
        borderBottom: `1px solid ${G.border}`,
        padding: "64px 0 52px",
      }}
    >
      <Wrap>
        <Label>{label}</Label>
        <BigTitle size="clamp(40px,5.5vw,76px)">{title}</BigTitle>
        <p style={{ fontSize: 16, color: G.muted, maxWidth: 580, lineHeight: 1.7, marginBottom: 0 }}>
          {sub}
        </p>
      </Wrap>
    </div>
  );
}
